/**
 * Product-card click-anywhere binder. Always loaded so collection suffixes that
 * omit find-product.js still get a truthful cursor:pointer.
 *
 * Scoped to .product-wrapper_item only. Mosaic and Rebuy already have their own
 * handlers; nav-drawer has its own too. Prefer the live <a> href (title or
 * visible Shop Now) so color-swatch / size JS keeps working without extra hooks.
 */
(function () {
  var CARD_SELECTOR = '.product-wrapper_item[data-link]';
  var NESTED_CONTROL_SELECTOR = 'a[href], button, input, select, textarea, label, [role="button"], .swiper-pagination, .swiper-button-prev, .swiper-button-next';

  function cardUrl(card) {
    var shopNow = card.querySelector('.price-wrapper:not(.hidden) a.shop_now');
    if (shopNow && shopNow.getAttribute('href')) return shopNow.getAttribute('href');

    var titleLink = card.querySelector('a.product-card__link[href]');
    if (titleLink && titleLink.getAttribute('href')) return titleLink.getAttribute('href');

    return card.getAttribute('data-link') || '';
  }

  function storeCollectionCrumbs(node) {
    if (!node) return;
    var source = node.closest && node.closest('[data-collection-handle]');
    if (!source && node.querySelector) source = node.querySelector('[data-collection-handle]');
    if (!source) source = node;
    if (!source.dataset) return;
    var handle = source.dataset.collectionHandle;
    var title = source.dataset.collectionTitle;
    if (!handle && !title) return;
    try {
      sessionStorage.removeItem('lastCollectionHandle');
      sessionStorage.removeItem('lastCollectionTitle');
      if (handle) sessionStorage.setItem('lastCollectionHandle', handle);
      if (title) sessionStorage.setItem('lastCollectionTitle', title);
    } catch (err) {}
  }

  function navigateCard(card) {
    var url = cardUrl(card);
    if (!url || /^javascript:/i.test(url)) return;
    storeCollectionCrumbs(card);
    window.location.href = url;
  }

  function isNestedControl(target, card) {
    var control = target.closest(NESTED_CONTROL_SELECTOR);
    return !!(control && card.contains(control) && control !== card);
  }

  function cardFromEvent(e) {
    if (e.target.closest('#nav-drawer')) return null;
    return e.target.closest(CARD_SELECTOR);
  }

  document.addEventListener('click', function (e) {
    var announcement = e.target.closest('[data-static-announcement-bar][data-link]');
    if (announcement && !e.target.closest('a[href], button')) {
      var announcementUrl = announcement.getAttribute('data-link');
      if (announcementUrl) window.location.href = announcementUrl;
      return;
    }

    var card = cardFromEvent(e);
    if (!card) return;

    storeCollectionCrumbs(card);
    if (isNestedControl(e.target, card)) return;

    e.preventDefault();
    navigateCard(card);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    var card = cardFromEvent(e);
    if (!card) return;

    if (e.target === card) {
      e.preventDefault();
      e.stopPropagation();
      navigateCard(card);
      return;
    }

    if (e.key === ' ' && e.target.closest('a[href]') && card.contains(e.target)) {
      var realLink = e.target.closest('a[href]');
      if (realLink && e.target === realLink) {
        e.preventDefault();
        realLink.click();
      }
    }
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-collection-handle]');
    if (!link) return;
    storeCollectionCrumbs(link);
  });
})();
